import React from 'react';
import styles from './styles.module.scss';

const Loader = () => (
  <div className={styles.loader}><img src='/assets/loader_tiny.gif' /></div>
)

export default Loader;